<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{$t('tracker.edit')}}</span>
  </template>

  <v-form ref="form" v-model="validEditor" lazy-validation>
    <name-text-field v-model="trackerName"></name-text-field>
    <device-selector v-model="trackerDevice" :ctrltypes="deviceTypes" :rules="deviceRules" :label="$t('tracker.device')"></device-selector>
    <state-selector v-model="trackerValue" :item="trackerDeviceInfo" :label="$t('tracker.device_state_to_track')" :hide-details="false" v-if="trackerDevice" class="mx-0"></state-selector>
    <v-select box v-model="trackerPending" :items="pendings" :label="$t('tracker.pending_minutes')"></v-select>
    <contact-selector v-model="trackerContacts" :rules="contactRules" :label="$t('tracker.emails_to_notify')"></contact-selector>
  </v-form>

  <template slot="actions">
    <v-btn v-if="isExisted" :disabled="saving" flat color="red" @click="remove">{{ $t('tracker.delete') }}</v-btn>
    <v-spacer></v-spacer>
    <v-btn :disabled="!validEditor" :loading="saving" flat color="primary" @click="save">{{ $t('tracker.save') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import NameTextField from '@/components/utils/NameTextField'
import DeviceItem from '@/components/device/DeviceItem'
import DeviceSelector from '@/components/device/DeviceSelector'
import DeviceStateSelector from '@/components/device/DeviceStateSelector'
import ContactSelector from '@/components/contact/ContactSelector'

export default {
  name: 'TrackerEditorDialog',
  mixins: [UserAuth],
  components: {
    'standard-dialog': Dialog,
    'name-text-field': NameTextField,
    'device-item': DeviceItem,
    'device-selector': DeviceSelector,
    'state-selector': DeviceStateSelector,
    'contact-selector': ContactSelector
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      saving: false,
      validEditor: false,
      trackerName: null,
      trackerDevice: null,
      deviceTypes: [23, 31, 36],
      deviceRules: [
        v => (v && v.length > 0) || this.$t('tracker.device_required')
      ],
      trackerValue: 0,
      trackerContacts: [],
      contactRules: [
        v => v.length > 0 || this.$t('tracker.contact_required')
      ],
      trackerPending: 5,
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    trackerDeviceInfo() {
      if (this.trackerDevice) {
        let key = this.trackerDevice;
        let [mac, uid, cid] = key.split('-');
        let d = (((this.userDevice[mac] || {})[`${mac}-${uid}`] || {}).channel || {})[key] || {};
        return {
          ...d,
          key: key,
          hostname: (this.userMacInfo[mac] || {}).hostname,
          targetName: ((this.userTargetName[mac] || {})[uid] || {})[cid]
        }
      }
    },
    isExisted() {
      return !!(this.data || {}).key;
    },
    contactToSave() {
      return this.trackerContacts.reduce((acc, cur) => {
        acc[cur] = this.userContact[cur];
        return acc;
      }, {});
    },
    pendings() {
      return [5, 10, 15, 20, 25, 30, 40, 50, 60].map(val => ({
        value: val,
        text: this.$t('tracker.minutes', {
          val: val
        })
      }));
    }
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      let ref = this.$db.ref('userStateTracker').child(this.userId);
      if (this.isExisted)
        ref = ref.child(this.data.key);
      else
        ref = ref.push();
      try {
        await ref.set({
          name: this.trackerName,
          device: this.trackerDevice,
          value: this.trackerValue,
          pending: this.trackerPending,
          notify: this.contactToSave
        });
      } catch (err) {
        this.$emit('toast', this.$t('tracker.permission_denied'));
        this.saving = false;
        return;
      }
      this.visible = false;
    },
    async remove() {
      let ref = this.$db.ref('userStateTracker').child(this.userId).child(this.data.key).remove()
        .then(() => this.visible = false)
        .catch(err => console.log(err));
    }
  },
  mounted() {
    if (this.data) {
      this.trackerName = this.data.name;
      this.trackerDevice = this.data.device;
      this.trackerValue = this.data.value || 0;
      this.trackerPending = this.data.pending || 5;
      this.trackerContacts = Object.keys(this.data.notify || {}) || [];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tracker/TrackerEditorDialog.vue